import { styled } from '@mui/material/styles';

export const Footer = styled('div', {
  shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
  display: active ? 'block' : 'none',
}));
